import React, { useState, useRef, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { Typography } from '@material-ui/core';
import { useAlreadyRegistered } from '../css/useAlreadyRegistered';
import alreadyRegisteredIcon from '../images/alreadyRegisteredIcon.png';

const MyEirAlreadyRegistered = props => {
    const containerRef = useRef(null);
    // const [isopen, setIsOpen] = useState(false);
    // const toggle = () => setIsOpen(!isopen);
    const classes = useAlreadyRegistered();
    const reactId = useRef(Math.random().toString(36).slice(2, 9));
    const modalBaseId = props.id || `custom-modal-${reactId.current}`;
    const titleId = props.heading || '';
    const descriptionId = props.newsContentText || '';

    const handleClickClose = () => {
        props.toggle();
    };
    const handleClickReset = () => {
        window.location.href = '/forgot-password';
    };

    const redirectToLogin = () => {
        handleClickClose();
        window.location.href = '/';
    };
    // useEffect(() => {
    //     if (props.isOpen) {
    //         document.getElementById(titleId)?.focus();
    //     }
    // }, [props.isOpen, titleId]);
    useEffect(() => {
        if (props.isOpen) {
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [props.isOpen]);
    return (
        <React.Fragment>
            {/* <div className={classes.alreadyRegisteredFooter} onClick={toggle}>
                <button className={'primary-cta footer-cta'}>Confirm</button>
            </div> */}
            <Modal
                className={classes.alreadyRegistredMain}
                wrapClassName={classes.alreadyRegistredMainWrapper}
                modalClassName={classes.alreadyRegistredMainModal}
                backdropClassName={classes.alreadyRegistredMainBackDrop}
                contentClassName={classes.alreadyRegistredMainContent}
                isOpen={props.isOpen}
                toggle={props.toggle}
                modalTransition={{ timeout: 300 }}
                role='dialog'
                aria-modal='true'
                aria-labelledby={titleId}
                aria-describedby={descriptionId}
                ref={containerRef}
                centered
            >
                <ModalBody className={classes.alreadyRegisteredWrapper}>
                    <div className={classes.registerTitleContainer}>
                        <div className={classes.registerPhone} id={titleId}>
                            <Typography
                                className={classes.registerTitle}
                                component='h2'
                                variant='h2'
                            >
                                {props.heading}
                            </Typography>
                            <div className={classes.registerTitleMobile}>{props.headingMobile}</div>
                        </div>
                    </div>
                    <div className={classes.alreadyRegisteredBody} id={descriptionId}>
                        <div className={classes.tickWrapper}>
                            <img
                                className={classes.tick}
                                src={alreadyRegisteredIcon}
                                alt='already Registered icon'
                            />
                        </div>
                        <div className={classes.newsTextWrapper}>
                            <div className={classes.newsText}>{props.newsContentText}</div>
                        </div>
                        <div className={classes.emailVerifiedWrapper}>
                            <div className={classes.emailVerifiedText}>{props.verifiedText}</div>
                            <div className={classes.emailVerifiedTextMobile}>
                                {props.verifiedTextMobile}
                            </div>
                        </div>
                        <div className={classes.emailVerifiedUsername}>{props.usernameEmail}</div>
                        <div className={classes.passwordInstructionWrapper}>
                            <div
                                className={classes.passwordInstructionPara}
                                dangerouslySetInnerHTML={{ __html: props.subtext }}
                            />
                        </div>
                    </div>
                    <div className={classes.alreadyRegisteredFooter}>
                        <button
                            className={'primary-cta footer-cta'}
                            onClick={
                                window.location.href.indexOf('/account/dashboard') > -1
                                    ? handleClickClose
                                    : window.location.href.indexOf('/create-password') > -1 ||
                                      window.location.href.indexOf('/forgot-email') > -1
                                    ? redirectToLogin
                                    : handleClickReset
                            }
                        >
                            {props.buttonText}
                        </button>

                        <div className='secondary-cta footer-cta'>
                            <span
                                style={{ cursor: 'pointer' }}
                                onClick={
                                    window.location.href.indexOf('/register') > -1
                                        ? redirectToLogin
                                        : handleClickClose
                                }
                            >
                                {props.footerText}
                            </span>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            {/* {resetScreen && <MyEirCreatePasswordFormPage />} */}
        </React.Fragment>
    );
};

export default MyEirAlreadyRegistered;
